/**
 * =============================================================================
 * IMPORTANT, READ THIS MESSAGE BEFORE EDITING THIS FILE.
 *
 * This file needs to be kept tightly in sync with its corresponding version in
 * the backend. If you are changing this file, please also make the
 * corresponding changes in: `functions/src/assignments/models/userAssignmentProgressMapInterfaces.ts`
 *
 * Be careful because import paths may be different and the APIs for
 * `firebase-admin` are different from `firebase/firestore`. Don't forget to
 * double check that you update the comments in `functions` as well.
 * =============================================================================
 */

import {AssignmentId} from 'assignments/types';

/** ============== COPY EVERYTHING STARTING HERE TO functions ============= */

export interface UserAssignmentProgressMap {
  /** Whether the user has completed the assignment. */
  [assignmentId: AssignmentId]: boolean;
}

/** ============== COPY EVERYTHING ENDING HERE TO functions ============= */

export function isUserAssignmentProgressMap(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  data: any,
): data is UserAssignmentProgressMap {
  return (
    typeof data === 'object' &&
    data !== null &&
    !Array.isArray(data) &&
    Object.keys(data).every(
      key => typeof key === 'string' && typeof data[key] === 'boolean',
    )
  );
}
